interface AmplitudeIdentify {
    set(key: string, value: string | number | boolean): void;
}

interface AmplitudeBrowser {
    Identify: new () => AmplitudeIdentify;
    add(plugin: unknown): void;
    identify(identify: AmplitudeIdentify): void;
    init(apiKey: string, options?: Record<string, unknown>): void;
    setUserId(userId: string): void;
    track(event: string, props?: Record<string, string | number | boolean>): void;
}

interface SessionReplayGlobal {
    plugin(options: { sampleRate: number }): unknown;
}

declare global {
    interface Window {
        amplitude?: AmplitudeBrowser;
        sessionReplay?: SessionReplayGlobal;
    }
}

let started = false;
let currentProduct = '';

export function initAnalytics(apiKey: string | null | undefined, product: string | null | undefined): void {
    const amplitude = window.amplitude;
    const sessionReplay = window.sessionReplay;

    if (started || !apiKey || !amplitude || !sessionReplay) {
        return;
    }

    started = true;
    currentProduct = product || '';

    amplitude.add(sessionReplay.plugin({ sampleRate: 1 }));
    amplitude.init(apiKey, {
        autocapture: { sessions: true, pageViews: true }
    });

    const identify = new amplitude.Identify();
    identify.set('product', currentProduct);
    amplitude.identify(identify);
}

interface AuthProfile {
    email?: unknown;
    name?: unknown;
    given_name?: unknown;
    family_name?: unknown;
}

function text(value: unknown): string {
    return typeof value === 'string' ? value.trim() : '';
}

function profileName(userData: AuthProfile): string {
    const name = text(userData.name);
    if (name.length > 0) {
        return name;
    }

    return (text(userData.given_name) + ' ' + text(userData.family_name)).trim();
}

export function identifyUser(userData: AuthProfile | null | undefined): void {
    const amplitude = window.amplitude;
    const email = text(userData && userData.email);
    const name = userData ? profileName(userData) : '';

    if (!amplitude || email.length === 0) {
        return;
    }

    amplitude.setUserId(email);
    const identify = new amplitude.Identify();
    identify.set('email', email);

    if (name.length > 0) {
        identify.set('name', name);
    }

    amplitude.identify(identify);
}

export function track(event: string, props: Record<string, string | number | boolean> = {}): void {
    const amplitude = window.amplitude;

    if (!amplitude) {
        return;
    }

    props.product = currentProduct;

    amplitude.track(event, props);
}
